export const LogoMark = ({ size = 36 }) => (
  <img
    src="/tillvia-mark.png"
    alt=""
    aria-hidden="true"
    width={size}
    height={size}
    style={{ width: size, height: size }}
    className="object-contain"
  />
);

export const Logo = ({ light = true }) => (
  <span className="inline-flex items-center gap-2.5">
    <LogoMark size={34} />
    <span className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-navy"}`}>
      Tillvia
    </span>
  </span>
);
